import { DISCOUNT_IDS } from '@constants/apiConstants';
import { Charge } from '@generated/gql/graphql';
import { BroadbandQuote } from '@src/types/broadband';
import { calculateDiscountedPrice, getQuoteMonthlyCharge } from '@utils/price';

// TODO might need removing if/when discount charge types are added
const activeDiscounts = [DISCOUNT_IDS.TBYB_BROADBAND_LINE_DISCOUNT];

const getDiscountedPrice = (quote: BroadbandQuote) => {
  const { discounts } = quote;
  const price = getQuoteMonthlyCharge(quote) as Charge;

  const validDiscounts = discounts
    .filter((discount) => discount.qualified)
    .filter((discount) => activeDiscounts.includes(discount.id));

  const discountedCostValue = validDiscounts.reduce(
    (acc, discount) => calculateDiscountedPrice(acc, discount),
    price.amount
  );
  return discountedCostValue;
};

export { getDiscountedPrice, activeDiscounts };
